// ----------------------------------------------------------------------------
// Component: Blog Posts
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';

// Styles
import 'snippets/swiper-control/swiper-control';
import './_blog-posts.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--blog-posts';
const CAROUSEL_CLASS = 'carousel--blog-posts';
const CAROUSEL_SECTION_SELECTOR = '.featured-blog-posts';
const CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';

const HOVER_FEATURE_CONTAINER_SELECTOR = CAROUSEL_SELECTOR;
const HOVER_FEATURE_SELECTOR           = '.card--post';
const HOVER_FEATURE_CLASS              = 'js--hover-active';


function addHoverFeature(container, item) {
    item.classList.add(HOVER_FEATURE_CLASS);
    container.classList.add(HOVER_FEATURE_CLASS);
}

function removeHoverFeature(container, item) {
    item.classList.remove(HOVER_FEATURE_CLASS);
    container.classList.remove(HOVER_FEATURE_CLASS);
}

function handleHoverFeature(event) {
    const item = event.target;
    const container = event.target.closest(HOVER_FEATURE_CONTAINER_SELECTOR);

    if (event.type === 'mouseenter') {
        setTimeout(addHoverFeature(container, item), 80);
    } else {
        setTimeout(removeHoverFeature(container, item), 80);
    }
}


// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for scroll bar
        element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-scrollbar-${index}`);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [ Scrollbar, A11y, Keyboard ],
            slidesPerView: 1.1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 2.1,
                    spaceBetween: 30,
                }
            },

            scrollbar: {
                el: `.${CAROUSEL_CLASS}-scrollbar-${index}`,
                draggable: true
            }
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink?.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });

        // element.addEventListener('mouseenter', handleHoverFeature);
        // element.addEventListener('mouseleave', handleHoverFeature);


        // Hover feature
        const articles = element.querySelectorAll(HOVER_FEATURE_SELECTOR);

        articles?.forEach(function(item) {
            item.addEventListener('mouseenter', handleHoverFeature);
            item.addEventListener('mouseleave', handleHoverFeature);
        });
    });